import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import LayersIcon from "@mui/icons-material/Layers";
import cssClasses from './Wings.module.css'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { IconButton } from "@mui/material";
import layersImg from '../Assets/Images/Common/Layers.png'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary
}));

export default function Wings({ wingName, isSelected, changeWingStatus, arrowClicked, showCheckbox }) {
    return (
        <Grid item xs={1} sm={1} md={1} lg={1}>
            <Item style={{ background: "#F2F4F7", border: "1px solid #F2F4F7", boxShadow: "unset", borderRadius: "0.8rem" }}>
                <div class={cssClasses.mainDiv}>
                    {showCheckbox &&
                        <div>
                            <label class={cssClasses.container}>
                                <input class={cssClasses.checkbox} type="checkbox" name="" id="" onChange={changeWingStatus} checked={isSelected} />
                                <span class={cssClasses.checkmark}></span>
                            </label>
                        </div>
                    }
                </div>
                <div style={{
                    padding: '2rem 3rem 0rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ width: "100%" }}>
                        {/* <LayersIcon style={{ color: "#98A2B3", fontSize: "3rem", marginBottom: "3rem" }} /> */}
                        <img src={layersImg} style={{ width: "4rem", height: "4rem", marginBottom: "3rem" }} alt="" />
                        <p style={{
                            fontFamily: 'Inter-Regular',
                            fontWeight: "600",
                            fontSize: "1.8rem",
                            lineHeight: "2.8rem",
                            color: "#101828"
                        }}>{wingName}</p>
                    </div>
                    <div>
                        <IconButton onClick={arrowClicked}>
                            <ExpandCircleDownIcon style={{
                                color: 'rgb(21, 112, 239)',
                                width: '2.6rem',
                                height: '2.6rem',
                                transform: 'rotate(270deg)'
                            }} />
                        </IconButton>
                    </div>
                </div>
            </Item>
        </Grid>
    );
}
